var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container d-flex align-items-center justify-content-center vh-100"},[_c('div',{staticClass:"alert alert-info text-center",staticStyle:{"font-size":"1.5em"},attrs:{"role":"alert"}},[_vm._v("\n    Actualmente estamos verificando tu información, para acceder a las funciones del sistema.\n  ")])])
}]

export { render, staticRenderFns }